import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UtilityModule } from '@sb/library/utility';
import { IframeComponent } from './iframe.component';

@NgModule({
    declarations: [
        IframeComponent
    ],
    imports: [
        CommonModule,
        UtilityModule
    ],
    exports:[
        IframeComponent
    ]
})
export class IframeModule { }
